import type { RefObject } from 'react';
import { useEffect } from 'react';

interface UseModalInteractionsProps {
    isOpen: boolean;
    onClose: () => void;
    modalRef: RefObject<HTMLElement>;
}

export function useModalInteractions({
    isOpen,
    onClose,
    modalRef,
}: UseModalInteractionsProps): void {
    useEffect(() => {
        function handleClickOutside(e: MouseEvent): void {
            if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
                onClose();
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            if (isOpen) {
                document.removeEventListener('mousedown', handleClickOutside);
            }
        };
    }, [isOpen, onClose, modalRef]);

    useEffect(() => {
        function handleEscapeKey(e: KeyboardEvent): void {
            if (e.key === 'Escape') onClose();
        }

        if (isOpen) {
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
}
